var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "portfolio__list" },
    [
      _vm._l(_vm.items, function (item, index) {
        return _c("li", { key: index, staticClass: "portfolio__list-item" }, [
          item.type === "image"
            ? _c(
                "a",
                {
                  attrs: {
                    href: "#",
                    "data-id": item.id,
                    "aria-label": "Посмотреть",
                  },
                  on: { click: _vm.showGalleryModal },
                },
                [
                  _c("picture", [
                    _c("source", {
                      attrs: {
                        srcset:
                          "./assets/img/" +
                          item.source +
                          "@1x.webp 1x, ./assets/img/" +
                          item.source +
                          "@2x.webp 2x",
                        type: "image/webp",
                      },
                    }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: "./assets/img/" + item.source + "@1x.jpg",
                        srcset: "./assets/img/" + item.source + "@2x.jpg 2x",
                        alt: item.description,
                        width: "787",
                        height: "589",
                      },
                    }),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          item.type === "video"
            ? _c(
                "a",
                {
                  attrs: {
                    href: "#",
                    "data-id": item.id,
                    "aria-label": "Посмотреть",
                  },
                  on: { click: _vm.showGalleryModal },
                },
                [
                  _c(
                    "video",
                    {
                      staticClass: "portfolio-video",
                      attrs: {
                        autoplay: "autoplay",
                        muted: "",
                        loop: "",
                        playsinline: "",
                        poster: "./assets/img/hero-logo.svg",
                      },
                      domProps: { muted: true },
                    },
                    [
                      _c("source", {
                        attrs: {
                          src: "./assets/video/" + item.source + ".mp4",
                          type: "video/mp4",
                        },
                      }),
                      _vm._v(" "),
                      _c("source", {
                        attrs: {
                          src: "./assets/video/" + item.source + ".webm",
                          type: "video/webm",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ])
      }),
      _vm._v(" "),
      !this.$props.items.length
        ? _c(
            "li",
            { staticClass: "portfolio__list-item portfolio__list-item--empty" },
            [
              _c("img", {
                attrs: {
                  src: "./assets/img/hero-logo.svg",
                  width: "100%",
                  height: "400",
                },
              }),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Кажется, вы не выбрали ни одного параметра фильтрации..."
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }